import IconType from "@/types/Icon.type";
import IconBicycleRouteAmenity from "@Icons/searchRes/amenities/IconBicycle";

/**
 * Ticket bicycle addon icon
 * Copy of a route amenities bicycle Icon
 */
function IconBicycle(props: IconType) {
    return (
        <IconBicycleRouteAmenity
            {...props}
        />
    )
}

export default IconBicycle;